import { IApiService } from 'web_core_library';
import { IDomainsCalculationPayload, IHighscoreResponse } from './types';

export function createEvaluationService() {
  let ApiService: IApiService;

  const getUserEvaluation = (domainId: number, limit: number, userId?: number) => {
    const filter = `domainid/${domainId}/limit/${limit}`;
    return ApiService.action<IDomainsCalculationPayload>('domain_calculation', {
      method: 'get',
      urlParams: {
        // override userId if given as argument
        userId: userId ?? ApiService.getUserId(),
        filter,
      },
    });
  };

  const getCycleEvaluation = (cycleId: number) => {
    const filter = `cycleid/${cycleId}`;
    return ApiService.action<IDomainsCalculationPayload>('domain_calculation', {
      method: 'get',
      urlParams: {
        userId: ApiService.getUserId(),
        filter,
      },
    });
  };

  const getHighscore = (workoutIds: number[], userId?: number) => {
    const workoutIdList = workoutIds.join(',');
    return ApiService.action<IHighscoreResponse[]>('users_highscore_statistics', {
      method: 'get',
      urlParams: {
        // override userId if given as argument
        userId: userId ?? ApiService.getUserId(),
      },
      params: {
        workoutIds: workoutIdList,
      },
    });
  };

  const service = {
    init: (ApiServiceInstance: IApiService) => {
      ApiService = ApiServiceInstance;
    },
    getUserEvaluation,
    getCycleEvaluation,
    getHighscore,
  };
  return service;
}

const EvaluationService = createEvaluationService();
export default EvaluationService;
